<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="mini"  type="primary" style="margin-bottom: 8px; " @click="back2Kdd">返回快递模板</el-button>
        <el-button size="mini" plain type="primary" style="margin-bottom: 8px; " @click="back2Print">返回打单</el-button>

      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <el-button  type="success" size="" @click="getAllDiv" style="margin-left: 320px; margin-bottom: 10px">保存自定义区</el-button>
        <el-button  type="danger"  @click="delItem" style="margin-left: 10px">删除选中项</el-button>

      </el-col>
    </el-row>


    <el-row style="margin-bottom: 20px">
      <el-col>
      </el-col>
      <el-col>
        <!--打印项-->
        <div id="left"style="width: 300px; position: relative; border: gray solid 1px; margin-right: 20px">
          <div style="height: 40px;vertical-align: middle; margin-top: 20px">
            <el-input v-model="myTitle" size="mini" placeholder="自定义文字" style="width: 230px"></el-input>
            <el-button size="mini" type="primary" style="" @click="addItem('a', '')">添加</el-button>
          </div>
          <el-table border :data="itemFields"  :show-header="false" :header-cell-style="{background:'#F2F6FC',color:'#000'}" ref="multipleTable"  >
            <el-table-column  prop="title" label="打印项" width="230px"></el-table-column>
            <el-table-column  label="" width="65px" >
              <template slot-scope="scope">
                <el-button type="primary" size="mini"  style="margin-top: 5px; margin-bottom: 5px" @click="addItem('d', scope.row.title)">添加</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!--面单-->
       <!-- <div id="content" style="height: 130mm; width: 70mm; position: absolute; left: 320px; top:0px; border: gray solid 1px">-->
        <div id="content" style="width: 70mm; height: 30mm; position: absolute; left: 320px; top:100px; border: gray solid 1px">
          <div id="top" style="display:none;height: 100mm; position: relative; overflow:hidden">
            <el-image disabled :src="bgpic"></el-image>
          </div>
          <div id="cover" style="display:none; height: 100mm; width: 100%; top: 0px; position: absolute; background:rgba(0, 0, 0, 0.4); filter:alpha(opacity=100); opacity:0.99;z-Index:100; "></div>

          <div id="divMain" style="height: 30mm; position: relative;" >
            <div id="tl" class="split"  style="cursor:se-resize"></div>
            <div id="tc" class="split" onmousedown="resize(event,'tc')" style="cursor:s-resize"></div>
            <div id="tr" class="split" onmousedown="resize(event,'tr')" style="cursor:ne-resize"></div>

            <div id="cl" class="split"  style="cursor:w-resize"></div>
            <div id="cr" class="split" onmousedown="resize(event,'cr')" style="cursor:w-resize"></div>

            <div id="bl" class="split"  style="cursor:ne-resize"></div>
            <div id="bc" class="split" onmousedown="resize(event,'bc')" style="cursor:s-resize"></div>
            <div id="br" class="split" onmousedown="resize(event,'br')" style="cursor:se-resize"></div>
          </div>
          <div style="margin-top: 30px">名称：{{tempName}}（模板自定义区）↑</div>
        </div>

        <!--样式-->
        <div id="stl" style="width:300px; position: absolute; top:0px; left: 750px; height: 130mm; border: gray solid 1px">
           <div style="margin-top: 20px; margin-left: 20px">
             <div style="margin-bottom: 20px">
                <span class="label">字体：</span>
                <el-select size="mini" style="width: 200px" v-model="fontName" @change="nameChange" placeholder="请选择" class="rightSpace">
                  <el-option
                    v-for="item in fontNames"
                    :key="item.title"
                    :label="item.title"
                    :value="item.title">
                  </el-option>
                </el-select>
             </div>
             <div style="margin-bottom: 20px">
              <span class="label">字号：</span>
              <el-input v-model="fontSize" placeholder="" size="mini" style="width: 60px" class="rightSpace" @input="sizeChange">10</el-input>
             </div>
             <div style="margin-bottom: 20px">
                <span class="label">对齐：</span>
                <el-radio-group v-model="buju" size="small" class="rightSpace" @change.native="bujuChange">
                  <el-radio-button label="left">左对齐</el-radio-button>
                  <el-radio-button label="center">居中</el-radio-button>
                  <el-radio-button label="right">右对齐</el-radio-button>
                </el-radio-group>
             </div>
              <div style="margin-bottom: 20px">
                <span class="label">样式：</span>
                <el-checkbox-group v-model="cuti" size="small" style="display: inline;top:-10px;" @change="cutiChange">
                  <el-checkbox-button v-for="city in cutis" :label="city.value"  :key="city.value">{{city.title}}</el-checkbox-button>
                </el-checkbox-group>
              </div>
           </div>
        </div>
      </el-col>
    </el-row>
    <div id="dpi" ref="dpi" style="width: 1cm;height:10px;  border: gold 0px solid; "></div>
    <el-button @click="showAllItems" v-show="false">DPI</el-button>

  </div>
</template>

<script>
    import $ from 'jquery'
    import dsgn from '../api/design';
    import $api from "../api/axios";
    import storage from "../api/storage";

    export default {
        name: "Design",
      data(){
          return{
            //一联 70*30mm 二联 100*40mm 蓝牙  70*12mm
            id:'',
            dpi: '378',
            //所属模板名称
            tempName:'',
            stdUrl:'',
            divCnt:0,
            fontName:'黑体',
            fontSize: 8,
            fontNames:[{title: '黑体'},{title: '宋体'},{title: 'Arial'},{title: 'Times New Roman'},
              {title: 'Tahoma'},{title: 'Arial Black'},{title: 'Arial Narrow'},{title: 'Arial Unicode MS'}],
            buju:'left',
            cuti:[],
            cutis:[{title:'粗体', value:'bold'},{title:'斜体', value:'italic'},{title:'下划线', value:'underline'} ],

            bgpic:'./static/image/back.jpg',
            myTitle: '',
            divItems:[{id:'d0', title:'预加载项目', left:'0', top:'0', width:'100', height:'25', fontFamily:'黑体',fontSize:'10', textAlign: 'center',fontStyle:'normal',fontWeight:'bold',textDecoration:'none'}],

            itemFields:[{title:'订单号', field:'tid'},{title:'买家昵称', field:'buyerNick'},{title:'卖家备注', field:'sellerMemo'},{title:'买家留言', field:'buyerMessage'},
              {title:'商品分类+件数+总计(换行)', field:'skuNumTotal'},{title:'商家编码+件数+总计(换行)', field:'outerNumTotal'},{title:'标题+件数+总计(换行)', field:'titleNumTotal'},
              {title:'简称+件数+总计(换行)', field:'shortNumTotal'},]
          }
      },
      methods:{
          one: function () {
            var content = document.getElementById("content");
            content.style.width = '70mm';
            content.style.height = '30mm';
            var divMain = document.getElementById("divMain");
            divMain.style.height = '30mm';
          },
        two: function () {
          //100*40
          var content = document.getElementById("content");
          content.style.width = '100mm';
          content.style.height = '38mm';
          var divMain = document.getElementById("divMain");
          divMain.style.height = '38mm';
        },
        getDpi:function(){
          console.log(this.$refs.dpi.offsetWidth);
          console.log(this.$refs.dpi.offsetHeight);

          this.dpi = this.$refs.dpi.offsetWidth;

        },
        back2Kdd:function () {
          this.$router.replace({name:'KddTemp'})
        },
        back2Print:function () {
          this.$router.replace({name:'Print'})
        },
        //添加 div  d 打印项， c 自定义
        addItem :function (t, title) {
          this.divCnt++;
          let divIdx = this.divCnt;
          //let childdiv="<div id=" + divIdx + " class='small' onclick='showPoint(\"" + divIdx + "\" )'  onmousedown='smallDown(event,\"" + divIdx + "\")'>" + row.title + "</div>"
          var divMain = document.getElementById("divMain");
          var newDiv = document.createElement("div");
          divIdx =  t + divIdx;
          newDiv.id =  divIdx;
          if (title=='')
            newDiv.innerText = this.myTitle;
          else
            newDiv.innerText = title;
          newDiv.style.left = 0;
          newDiv.style.top = 0;
          newDiv.style.width = 100 + 'px';
          newDiv.style.height = 25 + 'px';
          newDiv.style.fontFamily='黑体';
          newDiv.style.fontSize = 8 + 'pt';
          newDiv.style.textAlign ='left';
          newDiv.style.fontStyle='normal';
          newDiv.style.fontWeight='normal';
          newDiv.style.textDecoration='none';

          newDiv.setAttribute("class", "small");
          newDiv.setAttribute("onclick", "showPoint('" + divIdx + "')" );
          newDiv.setAttribute("onmousedown", "smallDown(event,'" + divIdx + "')" );
          divMain.append(newDiv);
          this.fontName = '黑体';
          this.fontSize = 8;
          this.buju = 'left';
          this.cuti = ["normal","normal","none"];
        },
        //显示后台保存的项目
        showAllItems:function(){
          this.delAllDiv();
          console.log("all items")
          let param = {
            nick:storage.get('nick'),
            tempId: this.id
          }
          $api.post("/setup/getAllItems", param, response =>{
            let dataResult =  response.data;
            console.log("aaa");
            console.log(dataResult);
            if(dataResult.state == 1 && dataResult.message == "ok"){
              this.divItems = dataResult.data.items;

              this.generateDiv();
            }else{
              this.$message.error(dataResult.message);
            }
          })
        },

        //动态创建DIV
        generateDiv:function(){
          var divMain = document.getElementById("divMain");
          for (let i = 0; i < this.divItems.length; i++) {
            this.divCnt++;
            let item = this.divItems[i];
            var newDiv = document.createElement("div");
            let divIdx = this.divCnt;
            if (item.did.indexOf('d') >= 0)
              divIdx = 'd' + divIdx;
            else if (item.did.indexOf('a') >= 0)
              divIdx = 'a' + divIdx;
            newDiv.id = divIdx;
            newDiv.innerText = item.title;
            newDiv.style.left = item.left + 'px';
            newDiv.style.top = item.top + 'px';
            newDiv.style.width = item.width + 'px';
            newDiv.style.height = item.height + 'px';
            newDiv.style.fontFamily = item.fontFamily;
            newDiv.style.fontSize = item.fontSize + 'pt';
            newDiv.style.textAlign = item.textAlign;
            newDiv.style.fontStyle = item.fontStyle;
            newDiv.style.fontWeight = item.fontWeight;
            newDiv.style.textDecoration = item.textDecoration;
            newDiv.setAttribute("class", "small");
            newDiv.setAttribute("onclick", "showPoint('" + divIdx + "')");
            newDiv.setAttribute("onmousedown", "smallDown(event,'" + divIdx + "')");
            divMain.append(newDiv);
          }
        },

        //复原选项
        fuYun: function(fn, fz, bj, ct){
          this.fontName = fn;
          this.fontSize = fz;
          this.buju =bj;
          this.cuti = ct;
        },
        //删除选中项
        delItem:function(){
          let changes =  document.getElementsByClassName("change");
          let osmall = changes[0];
          osmall.remove();

          /*let x= document.getElementById("content").offsetWidth;
          let y = document.getElementById("content").offsetHeight;
          alert(x / 76);
          alert(y);*/
        },
        nameChange:function(value){
          $(".change").css('font-family',value);
        },
        sizeChange:function(value) {
          if (value.length > 0) {
            this.fontSize = value;
            console.log(value);
            $(".change").css('font-size', value+'pt');
          }

        },
        bujuChange: function(value){
          console.log(this.cuti);
          $(".change").css('text-align', this.buju);
        },
        cutiChange:function(value){
          let sytle = '';
          for(let i=0;i<this.cuti.length;i++){
            sytle =sytle + "," + this.cuti[i];
            console.log(sytle);
          }
          if(sytle.indexOf("bold")>=0)
            $(".change").css('font-weight', 'bold');
          else
            $(".change").css('font-weight', 'normal');

          if(sytle.indexOf("italic")>=0)
            $(".change").css('font-style', 'italic');
          else
            $(".change").css('font-style', 'normal');

          if(sytle.indexOf("underline")>=0)
            $(".change").css('text-decoration', 'underline');
          else
            $(".change").css('text-decoration', 'none');

          /*$(".change").css('font-weight', 'bold'); text-decoration
          $(".change").css('font-style', 'italic');*/
        },
        //切换模板时，删除所有用户项
        delAllDiv: function(){
          var divs = $("#divMain div")
          for(var i=0; i<divs.length; i++) {
            var div = divs[i];
            var id = div.id;
            //排除定位块
            if ((id.indexOf("d") == 0) || ((id.indexOf("a") == 0))) {
              div.remove();
            }
          }
        },
        //遍历所有DIV
        getAllDiv: function () {
          let divStr='';
          var divs = $("#divMain div")
          for(var i=0; i<divs.length; i++){
            var div = divs[i];
            var id = div.id;
            //排除定位块
            if((id.indexOf("d")==0)||((id.indexOf("a")==0))){
              let fd = ' ';
              for(let j=0;j<this.itemFields.length;j++){
                if(this.itemFields[j].title == div.innerText){
                  fd = this.itemFields[j].field;
                }
              }
              divStr =divStr+ div.id + ","+ div.innerText +  "," +div.style.left+ ","+div.style.top+ ","+div.style.width+ ","+div.style.height
                  + ","+div.style.fontFamily+","+div.style.fontSize+","+div.style.textAlign+","+div.style.fontWeight
                  +","+div.style.fontStyle+","+div.style.textDecoration+ ","+ fd + ";";
            }
          }
          console.log(divStr);
          //this.id = 1001;
          //if(divStr.length>0){
            let param={
              nick: storage.get('nick'),
              tempId: this.id,
              tempName: this.tempName,
              divStr: divStr,
              dpi:this.dpi
            }
            $api.post("/setup/addItem", param, response =>{
              let dataResult =  response.data;
              if(dataResult.state == 1) {
                this.$message.success("保存自定义内容成功");
              }else {
                this.$message.error("保存自定义内容失败："+ dataResult.message);
              }
            })
          //}
        }

      },
      mounted(){

        let id = this.$route.params.id;
        let tempName = this.$route.params.tempName;
        let stdType = this.$route.params.stdType;
        if(id != undefined){
          storage.set("tempId", id);
          storage.set("temmpName", tempName);
        }else{
          id = storage.get("tempId")
          tempName = storage.get("tempName");
        }
        if(stdType == 1){
          this.two()
        }else{
          this.one()
        }
        this.id = id;
        this.tempName = tempName;
        this.showAllItems()

        window.showPoint = dsgn.showPoint;
        window.smallDown = dsgn.smallDown;
        window.resize = dsgn.resize;
        window.addItem = dsgn.addItem;
        window.fuYun = this.fuYun;



        //this.id = this.$router.params.id;




       /* var tmpNode = document.createElement( "DIV" );
        tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
        document.body.appendChild( tmpNode );
        arrDPI[0] = parseInt( tmpNode.offsetWidth );
        arrDPI[1] = parseInt( tmpNode.offsetHeight );
        tmpNode.parentNode.removeChild( tmpNode );
      */
      }
    }
</script>

<style >
  .small {
    background: #ccffff;
    position: absolute;
    cursor: pointer;
    cursor: text;
    left: 0px;
    top:0px;
    overflow: hidden;
    /*font-weight: bold;*/

  }
  .change {
    background: #ccffff;
    position: absolute;
    cursor: pointer;
    cursor: text;
    overflow: hidden;
  }
  .split{
     width: 4px;
     height: 4px;
     background: red;
     left: 5000px;
     top: 5000px;
     z-index: 1000000;
     position: absolute;
   }
  .label{
    font-size: 10px;
    margin-top: 5px;
  }
  .rightSpace{
    margin-right: 15px;
    margin-top: 5px;
  }

  .sel-table td{
    border: solid 0px #8cc5ff;
    border-bottom: solid 1px #8cc5ff;;
    height: 20px;
    padding: 5px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/print/Design.vue